import Checkbox from '@atoms/Checkbox/Checkbox';
import { ICheckbox } from '@models/ICheckbox';
import { useFormContext } from 'react-hook-form';

const CheckboxFormField = (props: ICheckbox) => {
  const { register } = useFormContext();

  return <Checkbox {...props} register={register} richTextLabel />;
};

export default CheckboxFormField;
